import script from "./RequestTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestTitle.vue?vue&type=script&setup=true&lang=js"

import "./RequestTitle.vue?vue&type=style&index=0&id=1689e24e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1689e24e"]])

export default __exports__